import { combineReducers } from "redux";

import Auth from "./auth/reducer";
import Layout from "./layout/reducer";
import Organisation from "./organisation/reducer";
import Employee from "./Employee/reducer";
import Leave from "./LeaveAndPermission/reducer";
import Attendence from "./Attendence/reducer"
import Reports from "./Reports/reducer";
import Dashboard from "./Dashboard/reducer"
import Location from "./Location/reducer"
import Masters from "./Masters/reducer"
import Project from "./Project/reducer"
const rootReducer = combineReducers({
  Auth,
  Layout,
  Organisation,
  Employee,
  Leave,
  Attendence,
  Reports,
  Dashboard,
  Location,
  Masters,
  Project,
});

export default rootReducer;
